(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/reducers/tipsinfo-reducer.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/reducers/tipsinfo-reducer.js');
"use strict";

const _RTK = RTK,
  createReducer = _RTK.createReducer;
const _svs$components$tipse = svs.components.tipsen.store.actions.couponSettingsActions,
  setTipsinfo = _svs$components$tipse.setTipsinfo,
  setResultTipsinfo = _svs$components$tipse.setResultTipsinfo,
  setMyBetsTipsinfo = _svs$components$tipse.setMyBetsTipsinfo,
  setOutcomeInfoChoises = _svs$components$tipse.setOutcomeInfoChoises,
  setShowVideoAnalysesInCoupon = _svs$components$tipse.setShowVideoAnalysesInCoupon,
  setShowMatchAnalysesInCoupon = _svs$components$tipse.setShowMatchAnalysesInCoupon,
  setMyBetsShowMatchAnalysesInCoupon = _svs$components$tipse.setMyBetsShowMatchAnalysesInCoupon,
  setResultShowMatchAnalysesInCoupon = _svs$components$tipse.setResultShowMatchAnalysesInCoupon;
const TipsinfoTypes = svs.components.tipsen.engine.constants.TipsinfoTypes;
const tipsinfoReducer = createReducer({}, builder => {
  builder.addCase(setTipsinfo, (state, action) => {
    for (const change of action.payload.changes) {
      state[action.payload.moduleName][change.field].state = change.state;
    }
  });
  builder.addCase(setResultTipsinfo, (state, action) => {
    for (const change of action.payload.changes) {
      state[action.payload.moduleName][change.field].stateResult = change.state;
    }
  });
  builder.addCase(setMyBetsTipsinfo, (state, action) => {
    for (const change of action.payload.changes) {
      state[action.payload.moduleName][change.field].stateMyBets = change.state;
    }
  });
  builder.addCase(setOutcomeInfoChoises, (state, action) => {
    const tipsInfoName = TipsinfoTypes.OutcomeLabel;
    for (const change of action.payload.changes) {
      state[action.payload.moduleName][tipsInfoName][change.field] = change.state;
    }
  });
  builder.addCase(setShowVideoAnalysesInCoupon, (state, action) => {
    const tipsInfoName = TipsinfoTypes.VideoAnalyses;
    for (const change of action.payload.changes) {
      state[action.payload.moduleName][tipsInfoName][change.field] = change.state;
    }
  });
  builder.addCase(setShowMatchAnalysesInCoupon, (state, action) => {
    const tipsInfoName = TipsinfoTypes.Analys;
    const _action$payload = action.payload,
      moduleName = _action$payload.moduleName,
      showMatchAnalyseInCouponOptions = _action$payload.showMatchAnalyseInCouponOptions;
    state[moduleName][tipsInfoName].bet.showAll = showMatchAnalyseInCouponOptions.showAll;
    state[moduleName][tipsInfoName].bet.showAnalyseForecast = showMatchAnalyseInCouponOptions.showAnalyseForecast;
    state[moduleName][tipsInfoName].bet.hideAll = showMatchAnalyseInCouponOptions.hideAll;
  });
  builder.addCase(setMyBetsShowMatchAnalysesInCoupon, (state, action) => {
    const tipsInfoName = TipsinfoTypes.Analys;
    const _action$payload2 = action.payload,
      moduleName = _action$payload2.moduleName,
      showMatchAnalyseInCouponOptions = _action$payload2.showMatchAnalyseInCouponOptions;
    state[moduleName][tipsInfoName].myBets.showAll = showMatchAnalyseInCouponOptions.showAll;
    state[moduleName][tipsInfoName].myBets.showAnalyseForecast = showMatchAnalyseInCouponOptions.showAnalyseForecast;
    state[moduleName][tipsInfoName].myBets.hideAll = showMatchAnalyseInCouponOptions.hideAll;
  });
  builder.addCase(setResultShowMatchAnalysesInCoupon, (state, action) => {
    const tipsInfoName = TipsinfoTypes.Analys;
    const _action$payload3 = action.payload,
      moduleName = _action$payload3.moduleName,
      showMatchAnalyseInCouponOptions = _action$payload3.showMatchAnalyseInCouponOptions;
    state[moduleName][tipsInfoName].result.showAll = showMatchAnalyseInCouponOptions.showAll;
    state[moduleName][tipsInfoName].result.showAnalyseForecast = showMatchAnalyseInCouponOptions.showAnalyseForecast;
    state[moduleName][tipsInfoName].result.hideAll = showMatchAnalyseInCouponOptions.hideAll;
  });
});
setGlobal('svs.components.tipsen.store.reducers.tipsinfoReducer', tipsinfoReducer);

 })(window);